import {
  IconCollapsed,
  IconExpanded,
} from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, ReactNode, useState } from 'react';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

type SectionHeadingProps = {
  title: string;
  /**
   * Anchor target for the drawer's anchor rail (NA-5579). Sits on the wrapper
   * rather than the content so a collapsed section is still reachable — and
   * stays collapsed when the anchor scrolls to it.
   */
  id?: string;
  initialOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
  children?: ReactNode;
};

export const SectionHeading: FC<SectionHeadingProps> = ({
  title,
  id,
  initialOpen = true,
  onToggle,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(initialOpen);

  const handleToggle = () => {
    const newState = !isOpen;
    setIsOpen(newState);
    onToggle?.(newState);
  };

  return (
    <div id={id} className={cx('section-heading-wrapper')}>
      <div className={cx('section-title-wrapper')}>
        <div className={cx('section-title')} onClick={handleToggle}>
          <span className={cx('title')}>{title}</span>
          <div className={cx('icon-container')}>
            {isOpen ? (
              <IconExpanded size={18} className={cx('icon')} />
            ) : (
              <IconCollapsed size={18} className={cx('icon')} />
            )}
          </div>
        </div>
      </div>

      {children && (
        <div
          className={cx('section-content', {
            [styles.collapsed]: !isOpen,
          })}
        >
          {children}
        </div>
      )}
    </div>
  );
};
